module.exports = __webpack_public_path__ + "img/logo_top.9f69ac59.png";